import React from 'react';
import { moreTestimonials } from '../data/content';
import { TestimonialCard } from './TestimonialCard';
export function MoreTestimonials() {
  return <section aria-labelledby="mas-testimonios-titulo" className="w-full bg-cream py-14 sm:py-20" data-id="element-173" data-mp="20fyp682evmpx">
      <div className="mx-auto max-w-6xl px-5" data-id="element-174" data-mp="25b4b36vtd1e0">
        <h2 id="mas-testimonios-titulo" className="text-center font-display text-2xl font-extrabold uppercase tracking-wide text-navy sm:text-3xl" data-id="element-175" data-mp="2a6tejlayf2fl">
          ❤️ Más familias y docentes que ya lo tienen
        </h2>

        <div className="mt-9 grid gap-5 md:grid-cols-2" data-id="element-176" data-mp="1hl0g1nwoy9ym">
          {moreTestimonials.map(testimonial => <TestimonialCard key={testimonial.name + testimonial.meta} testimonial={testimonial} layout="nameFirst" data-id="element-177" data-mp="1rhdaio028ruf" />)}
        </div>
      </div>
    </section>;
}